import React from 'react';
import { useCardBoxContext } from './card-box.provider';
import { StyledContent } from './card-box.styles';

export const CardBoxContent: React.FC = ({ children }) => {
    const { opened } = useCardBoxContext();

    if (!opened) {
        return null;
    }

    return (
        <StyledContent>
            {children}
        </StyledContent>
    );
};
